import { defineMessages } from "react-intl";

export const messages = defineMessages({
  pageType: {
    id: "V45+rx",
    defaultMessage: "Page type",
    description: "input label",
  },
  selectPageType: {
    id: "F0N1SC",
    defaultMessage: "Select a page type",
    description: "dialog header",
  },
});
